import ResetPasswordEmail from "./ResetPasswordEmail"
import ResetPasswordOTP from "./ResetPasswordOTP"
import { useResetPasswordContext } from "context/ResetPasswordContext"

const ResetPassword = () => {
    const { form } = useResetPasswordContext()

    const renderComponent = () => {
        switch (form.step) {
            case "email":
                return <ResetPasswordEmail />
            case "otp":
                return <ResetPasswordOTP />
        }
    }

    return <>{renderComponent()}</>
}

export default ResetPassword
